import { ElementRef } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { BackendPaths } from "@common/backend-paths";
import { InputFieldNames, InputFieldSizeType } from "@common/input-definitions";
import { DatePickerComponent } from "@input/date-picker/date-picker.component";
import { InputComponent } from "@input/input/input.component";
import { UserAutocompleteComponent } from "@input/user-autocomplete/user-autocomplete.component";
import { isAdminType, StateService } from "@services/state.service";
import { Subscription } from "rxjs";
import { DownloadDocumentComponent } from "@grid-cell/download-document.component";
import { orderStatuses, OrderType } from "../order-basic";
import { unsub } from "@util/utils";

const downloadColumn = {
  headerName: 'Download',
  width: 120,
  cellRenderer: DownloadDocumentComponent
};

const dateColumn = {
  field: 'date',
  headerName: 'Datum',
  width: 80
};

const createdByColumn = {
  field: 'createdBy',
  headerName: 'Erstellt von'
};

const documentNameColumn = {
  field: 'name',
  headerName: 'Dokument'
};

const montageLocations: any[] = [
  {
    id: 0,
    text: 'Wohnort'
  },
  {
    id: 1,
    text: 'MAG-Werkstatt'
  },
  {
    id: 2,
    text: 'anderer Montageort'
  }
];

export class EditOrdersComponentData {

  isAdmin: isAdminType = true;

  lastIsAdmin: isAdminType = true;

  autoSaving = false;

  allSelected = false;

  orderNum = '?';

  orderDateStr = (new Date()).toLocaleString('de');

  timesFC = new UntypedFormControl();

  locationFC = new UntypedFormControl();

  locations: any[] = montageLocations;

  h = 300;

  w = 600;

  showGrid = false;

  canDownload = true;

  noRowsTemplate = 'Keine Dokumente vorhanden';

  gridOptionsStored: any = {
    defaultColDef: {
      headerClass: function (params: any) {
        return 'def-col';
      },
      autoHeight: true,
    },
    columnDefs: [
      dateColumn,
      documentNameColumn,
      createdByColumn,
      downloadColumn
    ],
  };

  kindList: string[] = [
    'LKW',
    'PKW'
  ];

  cityList: string[] = [];

  zipList: string[] = [];

  damageList: string[] = [
    'Steinschlag durch vorausfahrendes Fahrzeug'
  ];

  useMyTabs = true;

  currentTabIdx = 0;

  tabIdx = 0;

  statuses: any[] = orderStatuses;

  teams: any[] = [];

  sbTypes: any[] = [
    {
      id: 1,
      name: 'Partner übernimmt SB'
    },
    {
      id: 2,
      name: 'Kunde zahlt SB'
    },
  ];

  sbStates: any[] = [
    {
      id: 0,
      name: 'offen'
    },
    {
      id: 1,
      name: 'Ja'
    },
  ];

  needStatus = false;
  statusTip= 'SB vor Ort kassieren';
  isCompleted =false;

  customersUrl = BackendPaths.CUSTOMERS;

  partnersUrl = BackendPaths.PARTNERS;

  customer: any;

  partner: any;

  data: OrderType = {
    damage_day: '',
    kind: '',
    status: 0,
    montage_loctype: 0,
    work_from: '',
    work_to: '',
    deductible_type: 1
  };

  montage_loctype = 0;

  id: string | number = '';

  teamId = 0;

  team: any;

  deviceSub!: Subscription;

  routeSub!: Subscription;

  stateSub!:Subscription;

  timesSub!: Subscription;

  dataRequestSub: Subscription | null = null;

  workTimes = '';

  timesValue = '';

  protected _articleNr!: InputComponent;

  protected _customerRef!: UserAutocompleteComponent;
  protected _halter!: InputComponent;
  protected _partnerRef!: UserAutocompleteComponent;
  protected _plate!: InputComponent;
  protected _km!: InputComponent;
  protected _kind!: InputComponent;
  protected _firstReg!: DatePickerComponent;
  protected _carDesc!: InputComponent;
  protected _damageDay!: DatePickerComponent;
  protected _damageLoc!: InputComponent;
  protected _damageNr!: InputComponent;
  protected _insurance!: InputComponent;
  protected _deductible!: InputComponent;
  protected _deductible_customer_part!: InputComponent;
  protected _workDay!: DatePickerComponent;
  protected _damage!: InputComponent;
  protected _montageAddress!: InputComponent;
  protected _montageCity!: InputComponent;
  protected _montageZip!: InputComponent;

  articleNrLength!: InputFieldSizeType;

  carDescLength!: InputFieldSizeType;
  carKindLength!: InputFieldSizeType;
  damageLength!: InputFieldSizeType;
  damageLocLength!: InputFieldSizeType;
  damageNrLength!: InputFieldSizeType;
  halterLength!: InputFieldSizeType;
  insuranceLength!: InputFieldSizeType;
  plateLength!: InputFieldSizeType;
  //
  addressLength!: InputFieldSizeType;
  cityLength!: InputFieldSizeType;
  zipLength!: InputFieldSizeType;

  protected _mainWrapper?: ElementRef;

  unsubAll() {
    this.deviceSub = unsub(this.deviceSub);

    this.routeSub = unsub(this.routeSub);

    this.timesSub = unsub(this.timesSub);

    this.dataRequestSub = unsub(this.dataRequestSub);

    this.stateSub = unsub(this.stateSub);
  }

  getAllRefs() {
    const refs: any = {};

    refs[InputFieldNames.ORDER_ARTICLE_NR] = this._articleNr;

    refs[InputFieldNames.ORDER_CUSTOMER_ID] = this._customerRef;
    refs[InputFieldNames.ORDER_HALTER] = this._halter;
    refs[InputFieldNames.ORDER_PARTNER_ID] = this._partnerRef;
    refs[InputFieldNames.ORDER_PLATE] = this._plate;
    refs[InputFieldNames.ORDER_KM] = this._km;
    refs[InputFieldNames.ORDER_CAR_KIND] = this._kind;
    refs[InputFieldNames.ORDER_MONTAGE_ADDRESS] = this._montageAddress;
    refs[InputFieldNames.ORDER_MONTAGE_ZIP] = this._montageZip;
    refs[InputFieldNames.ORDER_MONTAGE_CITY] = this._montageCity;
    refs[InputFieldNames.ORDER_FIRST_REG] = this._firstReg;
    refs[InputFieldNames.ORDER_CAR_DESCRIPTION] = this._carDesc;
    refs[InputFieldNames.ORDER_DAMAGE_DAY] = this._damageDay;
    refs[InputFieldNames.ORDER_DAMAGE_LOCATION] = this._damageLoc;
    refs[InputFieldNames.ORDER_DAMAGE_NR] = this._damageNr;
    refs[InputFieldNames.ORDER_INSURANCE] = this._insurance;
    refs[InputFieldNames.ORDER_DEDUCTIBLE] = this._deductible;
    refs[InputFieldNames.ORDER_DEDUCTIBLE_CUSTOMER_PART] = this._deductible_customer_part;

    refs[InputFieldNames.ORDER_WORK_DAY] = this._workDay;
    refs[InputFieldNames.ORDER_DAMAGE] = this._damage;

    return refs;
  }

  initSizes(stateService: StateService) {
    const il = (name: string) => {
      return stateService.getFieldSize(name);
    };

    this.articleNrLength = il(InputFieldNames.ORDER_ARTICLE_NR);

    this.carDescLength = il(InputFieldNames.ORDER_CAR_DESCRIPTION);
    this.carKindLength = il(InputFieldNames.ORDER_CAR_KIND);
    this.damageLength = il(InputFieldNames.ORDER_DAMAGE);
    this.damageLocLength = il(InputFieldNames.ORDER_DAMAGE_LOCATION);
    this.damageNrLength = il(InputFieldNames.ORDER_DAMAGE_NR);
    this.insuranceLength = il(InputFieldNames.ORDER_INSURANCE);
    this.halterLength = il(InputFieldNames.ORDER_HALTER);
    this.plateLength = il(InputFieldNames.ORDER_PLATE);

    this.addressLength = il(InputFieldNames.ORDER_MONTAGE_ADDRESS);
    this.cityLength = il(InputFieldNames.ORDER_MONTAGE_CITY);
    this.zipLength = il(InputFieldNames.ORDER_MONTAGE_ZIP);
  }

  backendUrl() {
    return BackendPaths.ORDERS_FULL + this.id;
  }
}
